jQuery(document).ready(function ($) {
  // $('body').on('mouseover', '.megaMenuTab', function(){
  //   $('.megaMenuTab > ul li:last-child > ul').addClass('megaHide');
  // });
  setTimeout(function () {
  $('#product-grid li').each(function(index) {
    var lenth = $(this).find('.swatch--gl').length;
    if(lenth > 1){
      //$(this).find('.swatch--gl:first-child').remove();
    }
  });
}, 5000);
  var owl = $(".owl_logo");
  owl.on(
    "initialize.owl.carousel initialized.owl.carousel " +
      "initialize.owl.carousel initialize.owl.carousel " +
      "resize.owl.carousel resized.owl.carousel " +
      "refresh.owl.carousel refreshed.owl.carousel " +
      "update.owl.carousel updated.owl.carousel " +
      "drag.owl.carousel dragged.owl.carousel " +
      "translate.owl.carousel translated.owl.carousel " +
      "to.owl.carousel changed.owl.carousel",
    function (e) {
      $("." + e.type)
        .removeClass("secondary")
        .addClass("success");
      window.setTimeout(function () {
        $("." + e.type)
          .removeClass("success")
          .addClass("secondary");
      }, 500);
    }
  );
  owl.owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    lazyLoad: true,
    margin: 30,
    video: true,
    autoplay:true,
    responsive: {
      0: {
        items: 1.5,
        margin: 30,
        stagePadding: 50,
      },
      600: {
        items: 3,
      },
      960: {
        items: 4,
      },
      1200: {
        items: 5,
        margin: 40,
      },
    },
  });
});
// $(document).ready(function() {
//  $(".product__description strong:contains('Key Features:')").parent().addClass('acc_head');
//  // $(".product__description strong:contains('Key Features:')").parent('p').addClass('acc_head');
//   $('.acc_head').append('<i class="fa fa-plus" aria-hidden="true"></i>')
//   $(".acc_head").on("click", function() {
//     $('.acc_head i').toggleClass('fa-plus fa-minus');
//     $(this).toggleClass("active");
//     $(this).next().slideToggle();
//   });
// });
jQuery(document).ready(function ($) {
  var owl = $(".cat_owl");
  owl.on(
    "initialize.owl.carousel initialized.owl.carousel " +
      "initialize.owl.carousel initialize.owl.carousel " +
      "resize.owl.carousel resized.owl.carousel " +
      "refresh.owl.carousel refreshed.owl.carousel " +
      "update.owl.carousel updated.owl.carousel " +
      "drag.owl.carousel dragged.owl.carousel " +
      "translate.owl.carousel translated.owl.carousel " +
      "to.owl.carousel changed.owl.carousel",
    function (e) {
      $("." + e.type)
        .removeClass("secondary")
        .addClass("success");
      window.setTimeout(function () {
        $("." + e.type)
          .removeClass("success")
          .addClass("secondary");
      }, 500);
    }
  );
  owl.owlCarousel({
    loop: true,
    nav: false,
    lazyLoad: true,
    margin: 20,
    video: true,
    stagePadding: 1,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      960: {
        items: 3,
      },
      1200: {
        items: 4,
      },
      1400: {
        items: 4,
      },
    },
  });
});

jQuery(document).ready(function ($) {
  var owl = $(".home-bottom-slider-owl");
  owl.on(
    "initialize.owl.carousel initialized.owl.carousel " +
      "initialize.owl.carousel initialize.owl.carousel " +
      "resize.owl.carousel resized.owl.carousel " +
      "refresh.owl.carousel refreshed.owl.carousel " +
      "update.owl.carousel updated.owl.carousel " +
      "drag.owl.carousel dragged.owl.carousel " +
      "translate.owl.carousel translated.owl.carousel " +
      "to.owl.carousel changed.owl.carousel",
    function (e) {
      $("." + e.type)
        .removeClass("secondary")
        .addClass("success");
      window.setTimeout(function () {
        $("." + e.type)
          .removeClass("success")
          .addClass("secondary");
      }, 500);
    }
  );
  owl.owlCarousel({
    loop: true,
    nav: false,
    lazyLoad: true,
    margin: 20,
    video: true,
    stagePadding: 1,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      960: {
        items: 1,
      },
      1200: {
        items: 1,
      },
      1400: {
        items: 1,
      },
    },
  });
});

jQuery(document).ready(function ($) {
  var owl = $(".owl-testimonial");
  owl.on(
    "initialize.owl.carousel initialized.owl.carousel " +
      "initialize.owl.carousel initialize.owl.carousel " +
      "resize.owl.carousel resized.owl.carousel " +
      "refresh.owl.carousel refreshed.owl.carousel " +
      "update.owl.carousel updated.owl.carousel " +
      "drag.owl.carousel dragged.owl.carousel " +
      "translate.owl.carousel translated.owl.carousel " +
      "to.owl.carousel changed.owl.carousel",
    function (e) {
      $("." + e.type)
        .removeClass("secondary")
        .addClass("success");
      window.setTimeout(function () {
        $("." + e.type)
          .removeClass("success")
          .addClass("secondary");
      }, 500);
    }
  );
  owl.owlCarousel({
    loop: true,
    nav: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0706/7418/6521/files/prev.png?v=1674195372'>",
      "<img src='https://cdn.shopify.com/s/files/1/0706/7418/6521/files/next.png?v=1674195372'>",
    ],
    lazyLoad: true,
    dots: false,
    margin: 15,
    video: true,
    stagePadding: 1,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      960: {
        items: 1,
      },
      1200: {
        items: 1,
      },
      1400: {
        items: 1,
      },
    },
  });

  $(".newsletter-form__field-wrapper .field__label").text(
    "Enter email address"
  );
  $(".compare_models .colum-4").hover(function () {
    $('.compare_models .colum-4').removeClass("active");
    $(this).addClass("active");
  }
)});

$(document).ready(function() { 
 $("#product_detail_reccome11 .collectionWish").click(function () {
    console.log("main");
       if($(this).hasClass('swym-added')) {
         console.log("If");
           $(this).children('span').text("Add to wishlist");
       }
      else{
        console.log("Else");
         $(this).children('span').text("Added to wishlist");
      }
    });
setTimeout(function(){
  //console.log("skjchskjdhfkdsf");
  $('body #product_detail_reccome11 .swym-added span').text('Added to wishlist');
},6000);
  
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
}); 
   $("div#shopify-block-bc1c1323-9f54-438b-a7a3-2e967b357891 .link").append(' customer reviews');
   $("#shopify-section-template--17559469392153__215455b5-8b07-45c3-8493-f644def50510 #Subscribe").text('Subscribe');
  
   $("#shopify-section-template--17559469326617__product-grid .collection_wish").click(function () {
       if($(this).hasClass('swym-added')) {
           $(this).children('span').text("Add to wishlist");
       }
      else{
         $(this).children('span').text("Added to wishlist");
      }
    });
           
setTimeout(function(){
  $('#shopify-section-template--17559469326617__product-grid .swym-added span').text('Added to wishlist');
}, 4000);
}); 
